import styles from '../AdminTools.module.css'
import { ChangeEvent, useEffect, useState } from 'react'
import { HeaderAlignedInput } from './AdminInputs/HeaderAlignedInput'
import { HeaderAlignedTaBortButton } from './AdminInputs/HeaderAlignedTaBortButton'
import { useDeleteProjectCache } from '../../../../fetchData/mutations/adminTools/useDeleteProjectCache'

export const DeleteProjectCache = () => {
  const [projectId, setProjectId] = useState<string>('')
  const deleteProjectCache = useDeleteProjectCache()

  useEffect(() => {
    if (deleteProjectCache.data?.success) setProjectId('')
  }, [deleteProjectCache.data?.success])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setProjectId(e.target.value)
  }

  const handleDelete = () => deleteProjectCache.mutate(projectId)

  return (
    <div className={styles.formContainer}>
      <h6 className={styles.inputGroupHeader}>Projektcache</h6>

      <HeaderAlignedInput
        label={'Projekt-id'}
        inputValue={projectId}
        handleChange={handleChange}
      />

      <HeaderAlignedTaBortButton
        handleClick={handleDelete}
        disabled={!projectId}
      />
    </div>
  )
}
